import React, { useState, useEffect, useCallback } from 'react';
import { FiRefreshCw } from 'react-icons/fi';
import axios from 'axios';

const RESTART_HEADER = { Authorization: 'Basic ' + btoa('Portal:Portal1163') };

const PingStatus = ({ pingUrl, restartKey, pingAuth, interval = 20000 }) => {
  const [online, setOnline] = useState(null);

  const ping = useCallback(async () => {
    try {
      const cfg = pingAuth ? { auth: pingAuth } : {};
      await axios.get(pingUrl, cfg);
      setOnline(true);
    } catch {
      setOnline(false);
    }
  }, [pingUrl, pingAuth]);

  const restart = useCallback(async () => {
    if (!window.confirm('Reiniciar o servidor?')) return;
    setOnline(null);
    try {
      await axios.post(
        `https://v1-csapi.compsoft.com.br:824/taskstart/${restartKey}`,
        null,
        { headers: RESTART_HEADER }
      );
    } catch (e) {
      console.error('Reiniciar falhou:', e);
    }
  }, [restartKey]);

  useEffect(() => {
    ping();
    if (!interval) return;
    const t = setInterval(ping, interval);
    return () => clearInterval(t);
  }, [ping, interval]);

  const dotClass = online === null ? 'cs-dot cs-dot-idle'
    : online ? 'cs-dot cs-dot-on'
    : 'cs-dot cs-dot-off';

  const label = online === null ? 'Verificando…' : online ? 'Online' : 'Offline';

  return (
    <span className="cs-ping-status">
      <span className={dotClass} title={label} />
      {restartKey && (
        <button className="cs-restart-btn" onClick={restart} title="Reiniciar serviço">
          <FiRefreshCw size={11} />
        </button>
      )}
    </span>
  );
};

export default PingStatus;
